import { type ReactElement } from "react";
import { Trans, useTranslation } from "react-i18next";
import { LegalIdentity } from "src/components/LegalInfo/legal-identity";
import { useBrand } from "src/hooks/useBrand";

export function ConsentLegalNotice(): ReactElement {
  const { t } = useTranslation();
  const { identity, dataProtectionPolicy } = useBrand();

  return (
    <section className="consent-platform-legal">
      <p>
        {t(
          "Vos données sont traitées par la Société {{brandName}}, filiale d'EMERIA Europe, responsable de traitement, sur la base de la relation contractuelle et de notre intérêt légitime. Elles sont conservées pendant une durée maximale de 5 ans après la fin de la relation contractuelle puis archivées ou supprimées conformément à nos obligations légales.",
          {
            brandName: identity.name,
          },
        )}
      </p>
      <p>
        <Trans
          i18nKey="Conformément à la loi n°78-17 du 6 janvier 1978 et au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits d'accès, d'opposition, de rectification, de portabilité, de limitation et de suppression de vos données personnelles sous certaines conditions. Pour exercer ces droits, veuillez contacter le Délégué à la Protection des Données (DPO) du Groupe Emeria via <formLink>le formulaire accessible ici</formLink>. Pour plus d'information, consultez <policyLink>notre politique sur la protection des données personnelles</policyLink>."
          components={{
            formLink: (
              <a
                href={dataProtectionPolicy.formUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("le formulaire accessible ici")}
              </a>
            ),
            policyLink: (
              <a
                href={dataProtectionPolicy.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(
                  "notre politique sur la protection des données personnelles",
                )}
              </a>
            ),
          }}
        />
      </p>
      <p>
        <LegalIdentity />
      </p>
    </section>
  );
}
